import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import Layout from "./layout/Layout";

/**
 * Reusable scaffold for informational/legal pages.
 * Renders breadcrumb → title → optional intro → sections.
 *
 * sections: Array<{ heading?: string, body: string | React.ReactNode }>
 */
const StaticPage = ({ title, intro, sections = [], crumb = title, children, testId }) => (
    <Layout>
        <section className="mx-auto max-w-4xl px-6 py-10 lg:px-12" data-testid={testId || "static-page"}>
            <nav className="mb-5 flex items-center gap-1 text-xs text-zinc-500">
                <Link to="/" className="inline-flex items-center gap-1 hover:text-brand-700"><Home className="h-3 w-3" /> Home</Link>
                <ChevronRight className="h-3 w-3" />
                <span className="text-zinc-700 dark:text-zinc-300">{crumb}</span>
            </nav>
            <header className="mb-8">
                <h1 className="text-3xl font-semibold tracking-tight text-zinc-900 sm:text-4xl dark:text-zinc-50">{title}</h1>
                {intro ? (
                    <p className="mt-3 max-w-2xl text-base leading-relaxed text-zinc-600 dark:text-zinc-300">{intro}</p>
                ) : null}
            </header>
            <div className="space-y-8">
                {sections.map((s, i) => (
                    <section key={i}>
                        {s.heading ? <h2 className="mb-2 text-lg font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">{s.heading}</h2> : null}
                        {typeof s.body === "string" ? (
                            <p className="text-sm leading-relaxed text-zinc-600 dark:text-zinc-300">{s.body}</p>
                        ) : s.body}
                    </section>
                ))}
                {children}
            </div>
            <footer className="mt-12 border-t border-zinc-100 pt-5 text-xs text-zinc-400 dark:border-white/10">
                Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}. For questions, email{" "}
                <a href="mailto:support@pills.asia" className="text-sky-600 hover:underline">support@pills.asia</a>.
            </footer>
        </section>
    </Layout>
);

export default StaticPage;
